var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navcontent" },
    [
      _vm._t("nav"),
      _c("div", { staticClass: "left-bar" }, [_vm._t("leftBar")], 2),
      _c("div", { staticClass: "right-nav-bar" }, [_vm._t("rightNavBar")], 2),
      _vm._t("rightBar"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }